module.exports = __webpack_public_path__ + "assets/img/plan_head1.51c688d8.jpg";